// export const rojoRemax = '#f52c24';
// export const rojoRemaxAlt = '#d90b21';
// export const azulRemax = '#04499e';

export const rojoRemax = '#AA1120'
export const rojoRemaxAlt = '#ff1200'

export const azulRemax = '#0C2749';
export const azulRemaxAlt = '#0043ff';

export const color = {
    crema: '#f7f5ee',
    blanco: '#FFFFFF',
    celeste: '#A3D4F2'
}

export const logos = {
    layout: '/img/2026/2.svg',
    layoutBlack: '/img/2026/1.svg',
    layoutAlt: '/img/2026/4.svg',
    layoutBlackAlt: '/img/2026/3.svg',
    footer: '/img/2026/2.svg',
}

export const fontFamily = 'Montserrat, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Arial, sans-serif';